var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.lang(_vm.$t("Opps! The page you're going to visit doesn't exist."))))]),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"action-btn h32",attrs:{"href":"home"}},[_c('p',[_vm._v(_vm._s(_vm.lang(_vm.$t("Go To Homepage"))))])])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8009ec04","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NotFound.vue
// module id = 1w9y
// module chunks = 2 3 4 5 6